import { useField } from 'formik';
import { Flex, Icon, Switch } from '@chakra-ui/react';
import { Stars03 } from '@kula-ai/icons/outline/Stars03';
import { KText } from '@/ui-library/components/text';

function NoteTakerField({ page, planData = {}, showFillWithAi = false }) {
  const [field, _meta, helpers] = useField('enable_note_taker');
  const [{ value: mandatoryValue }] = useField('note_taker_mandatory');
  const { setValue } = helpers;
  const { value } = field;
  const isNoteTakerEnabled = value || planData?.note_taker_mandatory;

  const onToggle = (event) => {
    const { checked } = event.target;
    setValue(checked);
  };

  return (
    <Flex
      bg="#F8F7FA"
      borderRadius="8px"
      p="12px"
      mx={page === 'add_interview' ? '24px' : '0px'}
      mb={showFillWithAi ? '0px' : '16px'}
      justifyContent="space-between"
      alignItems="center"
    >
      <Flex flexDir="column" gap="6px" flex="1">
        <Flex alignItems="center" gap="6px">
          <Icon as={Stars03} w="16px" h="16px" color="#605AFB" flexShrink={0} />
          <KText size="sm-semi-bold" color="secondary-900">
            Enable AI notetaker?
          </KText>
          {(mandatoryValue || planData?.note_taker_mandatory) && (
            <KText color="red.500" fontSize="14px">
              *
            </KText>
          )}
        </Flex>
        <KText size="sm-regular" color="secondary-700">
          The AI Notetaker automatically captures key points and summaries
          during meetings. It organizes and highlights information for easy
          review and follow-up.
        </KText>
      </Flex>
      <Switch
        className={`ats-switch-toogle ${isNoteTakerEnabled ? 'active' : ''}`}
        colorScheme="ats-primary"
        cursor="pointer"
        isChecked={isNoteTakerEnabled}
        disabled={mandatoryValue || planData?.note_taker_mandatory}
        onChange={onToggle}
        ml="12px"
        flexShrink={0}
      />
    </Flex>
  );
}

export default NoteTakerField;
